<template>
    <div class="popup_box">
        <van-popup v-model="show" class="popup">
            <p class="p1" @click="handleClose">关闭</p>
            <p class="p2">{{title}}</p>
            <div class="btn_box">
                <van-button @click="handleDetermine">确定</van-button>
                <van-button @click="handleClose">取消</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name:'popup',
    props:['title'],
    data() {
        return {
            show:false
        }
    },

    methods:{
        // 关闭
        handleClose() {
            this.show = false
        },

        // 确定
        handleDetermine() {
            this.$emit('handleDetermine')
        }
    }
}
</script>

<style lang="less" scoped>
.popup_box {
    .popup {
        width: 314px;
        height: 265px;
        background: #FFFFFF;
        border-radius: 6px;
        .p1 {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #303030;
            width: 100%;
            text-align: right;
            padding-top: 10px;
            padding-right: 10px;
        }
        .p2 {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #3B3B3B;
            line-height: 24px;
            margin-top: 30px;
            padding: 0 30px;
        }
        .btn_box {
            margin-top: 10px;
            padding: 27px;
            display: flex;
            flex-direction: column;
            /deep/.van-button--normal {
                border-radius: 25px;
                border: none;
                font-size: 16px;
            }
            /deep/.van-button--normal:nth-child(1) {
                background-color: #2660CE;
                color: #fff;
                margin-bottom: 20px;
            }
            /deep/.van-button--normal:nth-child(2) {
                background-color: #EFEFEF;
                color: #3B3B3B;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/modules/Allpopup/popup.vue